"use client";

import PriceWithUsd from "components/utilities/PriceWithUsd";
import useCurrency from "hooks/swr/useCurrency";
import { useBookingSummary } from "./useBookingSummary";
const ClientViewBlock = () => {
  const {
    formatter,
    rate
  } = useCurrency();
  const {
    daysLength,
    totalAmt,
    guestLabel,
    petSuffix,
    formattedDateRange
  } = useBookingSummary();
  return <div className='flex w-full flex-col gap-4' data-sentry-component="ClientViewBlock" data-sentry-source-file="ClientViewBlock.tsx">
      <p className='text-[14px] font-semibold leading-none tracking-[-0.14px] text-brand-dark'>
        What your client sees
      </p>
      <div className='flex flex-col gap-2'>
        <div className='flex items-center gap-2'>
          <p className='flex-1 text-[12px] font-medium leading-none tracking-[-0.12px] text-Gray-800'>
            {daysLength} {daysLength === 1 ? "night" : "nights"}
          </p>
          <p className='whitespace-nowrap text-[12px] font-medium leading-[1.2] text-Gray-700'>
            {formattedDateRange} • {guestLabel}
            {petSuffix}
          </p>
        </div>
        <div className='flex items-center gap-2'>
          <p className='whitespace-nowrap text-[14px] font-bold leading-none tracking-[-0.14px] text-brand-dark'>
            Total including taxes & fees
          </p>
          <p className='flex-1 text-right text-[16px] font-bold leading-none tracking-[-0.16px] text-brand-dark'>
            <PriceWithUsd price={formatter(0, 0).format(totalAmt * rate)} data-sentry-element="PriceWithUsd" data-sentry-source-file="ClientViewBlock.tsx" />
          </p>
        </div>
      </div>
    </div>;
};
export default ClientViewBlock;